import { render } from "./TsFooter.vue?vue&type=template&id=b217248c&scoped=true"
import script from "./TsFooter.vue?vue&type=script&lang=js"
export * from "./TsFooter.vue?vue&type=script&lang=js"

import "./TsFooter.vue?vue&type=style&index=0&id=b217248c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b217248c"]])

export default __exports__